// Dependencies
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { deleteIntegration } from '../../../actions/dashboard/integrationsActions';
// Components, actions, assets..
import CloseModalButton from '../CloseModalButton';

function DeleteIntegrationModal(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { closeModal, content } = props;
  const { id, isActive } = content;

  return (
    <>
      <div className="modal-header border-0 justify-content-center">
        <div className="w-100 d-flex flex-column align-items-center">
          <div className="col">
            <h6 className="header-pretitle text-center">{ t('components.modals.integrations.deleteIntegration.integration') }</h6>
            <h1 className="header-title text-center">{ t('components.modals.integrations.deleteIntegration.deleteYourIntegration') }</h1>
          </div>
        </div>
        <CloseModalButton closeModal={closeModal} />
      </div>
      <div className="container-fluid pt-5">
        <div className="col">
          <h4 className="text-center">{ t('components.modals.integrations.deleteIntegration.areYouSure') }</h4>
          <h4 className="text-center">
            { t('components.modals.integrations.deleteIntegration.byDeletingYour') }
          </h4>
          <h4 className="text-center">
            { t('components.modals.integrations.deleteIntegration.thisOperation') }
            <strong>{ t('components.modals.integrations.deleteIntegration.cannotBe') }</strong>
          </h4>
        </div>
        <div className="row justify-content-center pt-4 pb-5">
          <button
            type="submit"
            className="btn btn-danger"
            onClick={() => dispatch(deleteIntegration(id, isActive))}
          >
            { t('components.modals.integrations.deleteIntegration.deleteYourIntegration') }
          </button>
        </div>
      </div>
    </>
  );
}

export default DeleteIntegrationModal;

DeleteIntegrationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  content: PropTypes.shape({
    id: PropTypes.string,
    isActive: PropTypes.bool,
  }).isRequired,
};
